<app-quest-task-renderer [task]="node.Task"></app-quest-task-renderer>
